// extracted by mini-css-extract-plugin
export var active = "_8h-7";
export var container = "_8h-0";
export var evenWidth = "_8h-4";
export var large = "_8h-5";
export var outlet = "_8h-8";
export var slide = "_8h-2";
export var small = "_8h-6";
export var tab = "_8h-3";
export var tabs = "_8h-1";